import React from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmModal from './ConfirmModal';

interface CancelConfirmModalProps {
  visible: boolean;
  /** Discard changes and leave. */
  onConfirm: () => void;
  /** Keep editing (dismiss the modal). */
  onClose: () => void;
}

/**
 * Standard "discard unsaved changes?" confirmation shown when the user cancels
 * a create/edit form that has unsaved data (entity fields and/or KPIs).
 */
export default function CancelConfirmModal({ visible, onConfirm, onClose }: CancelConfirmModalProps) {
  const { t } = useTranslation();
  return (
    <ConfirmModal
      visible={visible}
      type="warning"
      title={t('common.discardChangesTitle')}
      message={t('common.discardChangesMessage')}
      confirmText={t('common.discardChanges')}
      cancelText={t('common.continueEditing')}
      onConfirm={onConfirm}
      onCancel={onClose}
    />
  );
}
